module.exports = __webpack_public_path__ + "img/branch.f69e04b7.png";